<template>
  <div class="user-block">

    <ul class="menu">
      <li>
        <router-link
            v-if="$store.getters.user && $store.getters.user.is_staff"
            class="btn btn-success fast-parse" title="Состояние сервиса" to="/status_page"><i class="bi bi-info-square-fill"></i> <span>Состояние сервиса</span>
        </router-link>
      </li>
      <li>
        <router-link
            v-if="$store.getters.tariff['history_parser']"
            class="btn btn-primary fast-parse" title="Единоразовый сбор данных" to="/parser"><i
            class="bi bi-arrow-clockwise"></i> <span>Быстрый сбор</span>
        </router-link>
      </li>

      <li>
        <a href="" @click.prevent="$modal('show', 'feedback')" class="btn btn-primary feedback-btn">
          <i class="bi bi-chat-dots"></i>
          <span>&nbsp;Обратная связь</span>
        </a>
      </li>
      <li class="bottom area">
        <div class="user-info">

          <div class="btn">
            {{ getShortName(user) }}
          </div>
          <ul class="user-menu">
            <li>
              <span class="name no-wrap">{{ user.fullname }}</span>
              <span class="username no-wrap">{{ user.username }}</span>
            </li>
            <li>
              <router-link to="/profile_settings" title="Настройки профиля">
                <i class="bi bi-person"></i> Настройки профиля
              </router-link>

            </li>
<!--            <li>-->
<!--              <router-link to="/tariff" title="Тарифы">-->
<!--                <i class="bi bi-wallet"></i> Тарифы-->
<!--              </router-link>-->

<!--            </li>-->
            <li>
              <a href="#" @click.prevent="logout" title="Выход" class="no-wrap">
                <i class="bi bi-box-arrow-right"></i> Выход
              </a>
            </li>
          </ul>
        </div>

        <Alerts></Alerts>
      </li>
    </ul>
    <button class="navbar-toggler d-md-none collapsed text-white" type="button"
            @click="$store.dispatch('toggle_sidebar')">
      <i v-if="!$store.getters.sidebar_state" class="bi bi-list"></i>
      <i v-else class="bi bi-x-lg"></i>
    </button>

    <modal modal_id="feedback">
      <template v-slot:header>
        <h1>Обратная связь</h1>
      </template>
      <template v-slot:body>
        <form action="." @submit.prevent="sendFeedBack()">
          <div>
            <textarea required class="form-control text-black" name="" id="" cols="30" rows="30" v-model="message"
                      placeholder="Введите ваше сообщение"></textarea>
            <button style="display: none" ref="feed_form" type="submit"></button>
          </div>
        </form>
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'feedback');"
                data-bs-dismiss="modal"> Отмена
        </button>
        <button type="button" class="btn btn-primary" v-on:click.prevent="$refs['feed_form'].click()">Отправить
        </button>
      </template>

    </modal>
    <modal modal_id="success_feedback">
      <template v-slot:header>
      </template>
      <template v-slot:body>
        <h3 class="text-dark">Спасибо. Ваше обращение принято в обработку</h3>
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'success_feedback');"
                data-bs-dismiss="modal"> Закрыть
        </button>
      </template>

    </modal>

  </div>
</template>
<script>


import {UserApi} from "@/api/user";
import Alerts from "@/components/alerts/Alerts.vue";

export default {
  name: 'TopBlock',
  components: {Alerts},
  data() {
    return {
      message: ""
    }
  },
  mounted() {

  },
  computed: {
    user: {
      get() {
        return this.$store.getters.user
      },
      set(value) {
        this.$store.dispatch('update_user', value)
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
    },
    getShortName(user) {
      if (user.fullname) return user.fullname.split(' ').map(x => x[0]).join('').toUpperCase()
      return user.username?.slice(0, 2).toUpperCase()
    },

    sendFeedBack() {
      UserApi.feedback({message: this.message}).then(() => {
        this.$modal('hide', 'feedback')
        this.$modal('show', 'success_feedback')
      })
    }

  },
  created: function () {

  }
}
</script>

<style scoped lang="scss">

.collapse{
  .bottom.area{
    padding: 5px;
  }
}

.user-block {
  margin-top: auto;
  margin-bottom: 5px;
  padding-top: 10px;

  ul {
    gap: 15px;
    display: flex;
    flex-direction: column;
    list-style-type: none;
    margin: 0;
    padding: 0;

    .btn {
      width: 90%;
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      padding-right: 20px;
    }

    .user-info {
      position: relative;

      &:hover {
        .user-menu {
          display: block;
        }
      }

      .btn {
        border-radius: 100px;
        background-color: var(--primary);
        font-weight: bold;
        font-size: 16px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--white);
      }

      .user-menu {
        position: absolute;
        left: 0;
        background: #fff;
        box-shadow: var(--shadow);
        border-radius: 5px;
        padding: 0;
        width: 200px;
        bottom: 37px;
        z-index: 10;
        list-style-type: none;
        display: none;
        animation: ease-in-out;
        animation-delay: 3s;

        li {
          padding: 10px;
          a, span{
            color: #000;
          }

          &:first-child {
            border-bottom: 1px solid var(--soft-grey);

            .name {
              font-weight: bold;
              display: block;
            }
          }

          &:last-child {
            border-top: 1px solid var(--soft-grey);

            a {
              color: var(--red);
              font-weight: bold;
            }

          }
        }
      }
    }
  }

}

textarea {
  height: 237px;
  max-height: 90%;

  &::placeholder {
    color: #000;
  }
}


</style>

